export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/task-calendar/:pageId',
        component: () => import('@/views/page/company/admin/task-calendar/TaskCalendar.vue'),
        name: 'task-calendar',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/task-management/:pageId',
        component: () => import('@/views/page/company/admin/task-management/List.vue'),
        name: 'task-management',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/client-task-management/:pageId',
        component: () => import('@/views/page/company/admin/client-task-management/List.vue'),
        name: 'client-task-management',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/team-task-management/:pageId',
        component: () => import('@/views/page/company/admin/team-task-management/List.vue'),
        name: 'team-task-management',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/work-status-timesheet/:pageId',
        component: () => import('@/views/page/company/admin/work-status-timesheet/List.vue'),
        name: 'work-status-timesheet',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-work-status-timesheet/:pageId',
        component: () => import('@/views/page/company/admin/my-work-status-timesheet/List.vue'),
        name: 'my-work-status-timesheet',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/open-deal/:pageId',
        component: () => import('@/views/page/company/admin/sales-pipeline/OpenDeal.vue'),
        name: 'open-deal',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/list/:pageId',
        component: () => import('@/views/page/company/admin/sales-pipeline/SalePipeline.vue'),
        name: 'sale-pipeline-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/open-deal/:salePipelineId/:pageId/edit',
        component: () => import('@/views/page/company/admin/sales-pipeline/OpenDeal.vue'),
        name: 'edit-deal',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:pageId/add',
        component: () => import('@/views/page/company/admin/sales-pipeline/AddQuotation.vue'),
        name: 'create-quotation',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:pageId/list',
        component: () => import('@/views/page/company/admin/sales-pipeline/QuotationList.vue'),
        name: 'quotation-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:pageId/edit/:quotationId',
        component: () => import('@/views/page/company/admin/sales-pipeline/EditQuotation.vue'),
        name: 'edit-quotation',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:pageId/deal-add',
        component: () => import('@/views/page/company/admin/sales-pipeline/DealAddQuotation.vue'),
        name: 'deal-create-quotation',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:pageId/deal-edit/:quotationId',
        component: () => import('@/views/page/company/admin/sales-pipeline/DealEditQuotation.vue'),
        name: 'deal-edit-quotation',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:pageId/create-bill/:quotationId',
        component: () => import('@/views/page/company/admin/sales-pipeline/QuotationAddBill.vue'),
        name: 'quotation-create-bill',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-pipeline/quotation/:quotationId/:pageId/edit-bill/:salesOrderId',
        component: () => import('@/views/page/company/admin/sales-pipeline/QuotationEditBill.vue'),
        name: 'quotation-edit-bill',
        meta: {
            requiresAuth: true
        }
    },
]
